export function hm(url){
    let hm = "chile";
    if(url && url.search("/") > -1){
        const splitUrl = url.split("/");
        if(splitUrl.length > 1)
         hm = splitUrl[2];
    }  
    return hm;
}

export function language(url: string){
    let language = "es";
    if(url && url.search("/") > -1){
        const splitUrl = url.split("/");
        if(splitUrl.length > 1)
            language = splitUrl[1];
    }    
    return language;
}
